import React from "react";
import { derhumOrangeSign } from "../../utils/data";

const CurrencyDisplay = ({
  amount,
  className = "text",
  size = "normal",
  signOptions = {},
}) => {
  if (amount === null || amount === undefined) {
    return null;
  }

  const symbol = process.env.REACT_APP_CURRENCY_SYMBOL || "AED";
  const placement = process.env.REACT_APP_CURRENCY_PLACEMENT || "LEFT";

  // Size variants
  const sizeClasses = {
    small: "text-sm",
    normal: "text-base",
    large: "text-lg",
    xl: "text-xl",
    "2xl": "text-2xl",
    "3xl": "text-3xl",
    "4xl": "text-4xl",
  };

  const sizeClass = sizeClasses[size] || sizeClasses.normal;

  if (symbol === "SIGN") {
    // For SVG symbols, render the SVG directly as React elements
    const svgElement = (
      <svg
        width={signOptions.width || "25"}
        height={signOptions.height || "21"}
        viewBox="0 0 25 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="inline-block align-middle"
      >
        <path
          d="M24.1035 9.97894L23.9211 9.81052C23.6263 9.52982 23.2754 9.38947 22.8965 9.38947H20.9316C20.9597 9.72631 20.9737 10.0632 20.9737 10.4281C20.9737 10.793 20.9597 11.1298 20.9316 11.4807H22.2649C23.2754 11.4807 24.1035 12.4351 24.1035 13.6281V14.1614L23.9211 13.9789C23.6263 13.7123 23.2754 13.5719 22.8965 13.5719H20.6369C19.5561 18.3018 15.7807 20.8702 9.82983 20.8702H2.19475C2.19475 20.8702 3.23335 20.0702 3.23335 17.3895V14.5719H1.95615C0.931594 14.5719 0.103516 13.6035 0.103516 12.4246V10.8912L0.300012 11.0596C0.580713 11.3263 0.931597 11.4807 1.31054 11.4807H3.23335V9.38947H1.95615C0.931594 9.38947 0.103516 8.42105 0.103516 7.2421V5.70877L0.300012 5.89123C0.580713 6.15789 0.931597 6.29824 1.31054 6.29824H3.23335V3.63509C3.23335 0.870176 2.19475 0 2.19475 0H9.82983C15.6123 0 19.486 2.54035 20.6228 7.29824H22.2649C23.2754 7.29824 24.1035 8.25263 24.1035 9.44561V9.97894ZM9.54912 1.0386H7.36317V6.29824H17.0719C16.3421 1.94737 13.8579 1.0386 9.54912 1.0386ZM17.3246 10.4281C17.3246 10.0632 17.3105 9.72631 17.2965 9.38947H7.36317V11.4807H17.2965C17.3105 11.1298 17.3246 10.793 17.3246 10.4281ZM7.36317 19.8175H9.5772C14.1386 19.7053 16.3842 18.5158 17.0719 14.5719H7.36317V16.6947V19.8175Z"
          fill={signOptions.color || "#135EA0"}
        />
      </svg>
    );

    return (
      <span
        className={`inline-flex items-center whitespace-nowrap ${sizeClass} ${className}`}
      >
        {placement.toUpperCase() === "RIGHT" ? (
          <>
            {amount} {svgElement}
          </>
        ) : (
          <>
            {svgElement} {amount}
          </>
        )}
      </span>
    );
  }

  // For regular text symbols
  return (
    <span className={`${sizeClass} ${className}`}>
      {placement.toUpperCase() === "RIGHT"
        ? `${amount} ${symbol}`
        : `${symbol} ${amount}`}
    </span>
  );
};

export default CurrencyDisplay;
